import React, { createContext, useContext, useState, useEffect } from 'react';

interface LocationContextType {
    latitude: number | null;
    longitude: number | null;
    setLatitude: (lat: number) => void;
    setLongitude: (lng: number) => void;
}

const LocationContext = createContext<LocationContextType | undefined>(undefined);

export const LocationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [latitude, setLatitude] = useState<number | null>(null);
    const [longitude, setLongitude] = useState<number | null>(null);


    console.log(latitude, longitude, "mmmmmwwwwwwwww")
    return (
        <LocationContext.Provider value={{ latitude, longitude, setLatitude, setLongitude }}>
            {children}
        </LocationContext.Provider>
    );
};

export const useLocation = (): LocationContextType => {
    const context = useContext(LocationContext);
    console.log(context, "contextcontext3333")
    if (!context) {
        throw new Error('useLocation must be used within a LocationProvider');
    }
    return context;
};